/**
 * quantity-multiplier.js — Yakups toptan (SET) ürün sayfası mantığı — CONCEPT TEMA SÜRÜMÜ
 *
 * Wonder temasındaki sürümden port edildi. Parser / stok / set doğrulama mantığı BİREBİR korundu;
 * yalnız tema entegrasyonu Concept 5.3.3'e uyarlandı:
 *   - Sepete ekleme: temanın product-form fetch('/cart/add') isteği yakalanır, set TEK istekte
 *     (items: [...]) eklenir, temanın beklediği "sections" cevabı olduğu gibi geri döner.
 *   - Set kutusu / set toplam fiyatı: .product__price bloğunun ALTINA (blok dışına) konur;
 *     varyant değişince tema #Price-… içini yeniden çizdiği için içine konmaz.
 *   - Varyant değişimi: theme.pubsub "variantChange" (variant.price ile set toplamı yenilenir).
 *   - Adet sınırı: input max + temanın quantity-input doğrulaması; buton klonlama YOK.
 */
(function () {
  'use strict';

  let isInitialized = false;
  let isProcessingRequest = false;
  let allSizeVariants = [];
  let sizeVariantStocks = {};
  let sizeDistribution = {};
  let variantDistributions = {};
  let isBedenSetiFormat = false;
  let minStockQuantity = 0;
  let availableSizes = [];
  let internalRequestFlag = 'SET_MULTIPLIER_INTERNAL_REQUEST';
  let isPaketYapisiFormat = false;
  let paketMultiplier = 1;
  let currentPriceCents = 0;
  const PRODUCTION_MODE = false; // debug konsol logları AÇIK ([Set Multiplier] ...)

  // ===== i18n / Çoklu dil desteği =====
  const I18N_STRINGS = {
    tr: {
      bedenSetiTitle: 'Beden Seti:',
      bedenSetiAutoDesc: 'Ürünler, seçtiğiniz bedene göre farklı miktarlarda otomatik olarak sepetinize eklenecektir.',
      rangeNotice: '<span style="color: #007cba; font-weight: 500;">{range}</span> seçerseniz → <strong>{qty} adet</strong> ürün eklenecektir',
      paketTitle: 'Paket Ürün:',
      paketDescription: 'Sipariş ettiğiniz her 1 adet için {qty} adet ürün sepetinize eklenecektir.',
      paketSubtitle: 'Bu ürün paket olarak satılmaktadır.',
      setTitle: 'Set Ürün:',
      setStdDescription: 'Sipariş ettiğiniz her 1 adet için {qty} adet ürün sepetinize eklenecektir.',
      setSubtitle: 'Bu ürün set olarak satılmaktadır.',
      setMultiDescription: 'Her birim için, farklı bedenlerde {qty} ürün sepetinize eklenecektir.',
      distributionLabel: 'Dağılım:',
      pcsUnit: 'adet',
      pkgUnit: 'paket',
      pkgUnitPlural: 'paket',
      setUnit: 'set',
      maxAddableLabel: 'Maksimum eklenebilir:',
      limitingFactorLabel: 'Sınırlayıcı faktör:',
      yourSelectionLabel: 'Seçiminiz:',
      addingToCartLabel: 'Sepete ekleniyor:',
      detailsLabel: 'Detaylar:',
      cantAddTitle: '⚠ Eklenemez',
      setProcessingMsg: 'Set işleniyor...',
      productsAddedMsg: '{qty}{formatInfo} ({total} adet) ürün eklendi',
      formatSetSize: ' (Beden Seti)',
      formatPackage: ' (Paket)',
      formatSet: ' (Set)',
      cantAddIntegrityMsg: 'Ürün sepete eklenemedi çünkü set bütünlüğü sağlanamıyor.',
      missingSizesErr: 'Eksik bedenler: {sizes}',
      insufficientStockMaxSetsErr: 'Stok yetersiz. Maksimum {max} set eklenebilir. Sınırlayıcı faktör: {factor}',
      insufficientStockSimpleErr: 'Stok yetersiz: {available} < {needed}',
      sizeNotFoundErr: '{size} bedeni bulunamadı',
      pkgInsufficientWarn: 'Stok yetersiz! Bu paket ürün sepete eklenemez.',
      stdInsufficientWarn: 'Stok yetersiz! Bu ürün sepete eklenemez.',
      setIntegrityWarn: 'Set bütünlüğü sağlanamıyor! Eksik bedenler var.',
      maxAddableWarn: 'Maksimum {max} {format} ({total} adet) eklenebilir!',
      maxSetsOnlyWarn: 'Maksimum {max} set eklenebilir',
      setTotalLabel: 'Set toplamı:',
      unitPriceNote: 'birim',
      addingToCartOverlay: 'Ürünler sepete ekleniyor…'
    },
    ro: {
      bedenSetiTitle: 'Set de mărimi:',
      bedenSetiAutoDesc: 'Produsele vor fi adăugate automat în coșul dumneavoastră în cantități diferite, în funcție de mărimea selectată.',
      rangeNotice: '<span style="color: #007cba; font-weight: 500;">{range}</span> dacă selectați → <strong>{qty} buc.</strong> produse vor fi adăugate',
      paketTitle: 'Produs pachet:',
      paketDescription: 'Pentru fiecare 1 bucată comandată, {qty} bucăți vor fi adăugate în coșul dumneavoastră.',
      paketSubtitle: 'Acest produs se vinde ca pachet.',
      setTitle: 'Produs set:',
      setStdDescription: 'Pentru fiecare 1 bucată comandată, {qty} bucăți vor fi adăugate în coșul dumneavoastră.',
      setSubtitle: 'Acest produs se vinde ca set.',
      setMultiDescription: 'Pentru fiecare bucată, {qty} produse de mărimi diferite vor fi adăugate în coșul dumneavoastră.',
      distributionLabel: 'Distribuție:',
      pcsUnit: 'buc.',
      pkgUnit: 'pachet',
      pkgUnitPlural: 'pachete',
      setUnit: 'set',
      maxAddableLabel: 'Maximum adăugabil:',
      limitingFactorLabel: 'Factor limitativ:',
      yourSelectionLabel: 'Selecția dvs.:',
      addingToCartLabel: 'Se adaugă în coș:',
      detailsLabel: 'Detalii:',
      cantAddTitle: '⚠ Nu se poate adăuga',
      setProcessingMsg: 'Setul se procesează...',
      productsAddedMsg: '{qty}{formatInfo} ({total} buc.) produse adăugate',
      formatSetSize: ' (Set mărimi)',
      formatPackage: ' (Pachet)',
      formatSet: ' (Set)',
      cantAddIntegrityMsg: 'Produsul nu a putut fi adăugat în coș deoarece integritatea setului nu poate fi menținută.',
      missingSizesErr: 'Mărimi lipsă: {sizes}',
      insufficientStockMaxSetsErr: 'Stoc insuficient. Maximum {max} seturi pot fi adăugate. Factor limitativ: {factor}',
      insufficientStockSimpleErr: 'Stoc insuficient: {available} < {needed}',
      sizeNotFoundErr: 'Mărimea {size} nu a fost găsită',
      pkgInsufficientWarn: 'Stoc insuficient! Acest produs pachet nu poate fi adăugat în coș.',
      stdInsufficientWarn: 'Stoc insuficient! Acest produs nu poate fi adăugat în coș.',
      setIntegrityWarn: 'Integritatea setului nu poate fi menținută! Lipsesc mărimi.',
      maxAddableWarn: 'Maximum {max} {format} ({total} buc.) pot fi adăugate!',
      maxSetsOnlyWarn: 'Maximum {max} seturi pot fi adăugate',
      setTotalLabel: 'Total set:',
      unitPriceNote: 'buc.',
      addingToCartOverlay: 'Produsele se adaugă în coș…'
    },
    en: {
      bedenSetiTitle: 'Size Set:',
      bedenSetiAutoDesc: 'Products will be automatically added to your cart in different quantities based on the size you select.',
      rangeNotice: 'If you select <span style="color: #007cba; font-weight: 500;">{range}</span> → <strong>{qty} pcs</strong> will be added',
      paketTitle: 'Package Product:',
      paketDescription: 'For every 1 unit you order, {qty} products will be added to your cart.',
      paketSubtitle: 'This product is sold as a package.',
      setTitle: 'Set Product:',
      setStdDescription: 'For every 1 unit you order, {qty} products will be added to your cart.',
      setSubtitle: 'This product is sold as a set.',
      setMultiDescription: 'For each unit, {qty} products in different sizes will be added to your cart.',
      distributionLabel: 'Distribution:',
      pcsUnit: 'pcs',
      pkgUnit: 'package',
      pkgUnitPlural: 'packages',
      setUnit: 'set',
      maxAddableLabel: 'Maximum addable:',
      limitingFactorLabel: 'Limiting factor:',
      yourSelectionLabel: 'Your selection:',
      addingToCartLabel: 'Adding to cart:',
      detailsLabel: 'Details:',
      cantAddTitle: '⚠ Cannot be added',
      setProcessingMsg: 'Processing set...',
      productsAddedMsg: '{qty}{formatInfo} ({total} pcs) products added',
      formatSetSize: ' (Size Set)',
      formatPackage: ' (Package)',
      formatSet: ' (Set)',
      cantAddIntegrityMsg: 'The product could not be added to the cart because set integrity cannot be maintained.',
      missingSizesErr: 'Missing sizes: {sizes}',
      insufficientStockMaxSetsErr: 'Insufficient stock. A maximum of {max} sets can be added. Limiting factor: {factor}',
      insufficientStockSimpleErr: 'Insufficient stock: {available} < {needed}',
      sizeNotFoundErr: 'Size {size} not found',
      pkgInsufficientWarn: 'Insufficient stock! This package product cannot be added to the cart.',
      stdInsufficientWarn: 'Insufficient stock! This product cannot be added to the cart.',
      setIntegrityWarn: 'Set integrity cannot be maintained! There are missing sizes.',
      maxAddableWarn: 'A maximum of {max} {format} ({total} pcs) can be added!',
      maxSetsOnlyWarn: 'A maximum of {max} sets can be added',
      setTotalLabel: 'Set total:',
      unitPriceNote: 'unit',
      addingToCartOverlay: 'Adding products to cart…'
    }
  };

  function getInfo() {
    return window.productVariantInfo || {};
  }

  function getCurrentLocale() {
    const info = getInfo();
    const raw = (info.locale || 'tr').toString().toLowerCase();
    const short = raw.slice(0, 2);
    return I18N_STRINGS[short] ? short : 'tr';
  }

  function t(key, vars) {
    const locale = getCurrentLocale();
    const dict = I18N_STRINGS[locale] || I18N_STRINGS.tr;
    let str = dict[key];
    if (str === undefined) str = (I18N_STRINGS.tr[key] !== undefined) ? I18N_STRINGS.tr[key] : key;
    if (vars) {
      for (const k in vars) {
        str = str.split('{' + k + '}').join(vars[k]);
      }
    }
    return str;
  }

  let debounceTimers = {};
  function debounce(key, callback, delay = 300) {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(callback, delay);
  }

  function log(...args) {
    if (!PRODUCTION_MODE) {
      console.log('[Set Multiplier]', ...args);
    }
  }

  function logError(...args) {
    console.error('[Set Multiplier Error]', ...args);
  }

  // ============================================================
  // CONCEPT TEMA BAĞLAMI: product-info / form / adet input'u
  // ============================================================
  const ctx = { sectionId: null, productId: null, formId: null, productInfo: null };

  function resolveContext() {
    const info = getInfo();
    const pid = String(info.productId || '');
    const all = document.querySelectorAll('product-info');
    let pi = null;
    for (const el of all) {
      if (String(el.getAttribute('data-product-id')) === pid) { pi = el; break; }
    }
    if (!pi && all.length) pi = all[0];
    if (!pi) return false;
    ctx.productInfo = pi;
    ctx.sectionId = pi.getAttribute('data-original-section-id') || pi.getAttribute('data-section-id');
    ctx.productId = pi.getAttribute('data-product-id');
    ctx.formId = pi.getAttribute('form');
    return true;
  }

  function getProductForm() {
    if (ctx.formId) {
      const f = document.getElementById(ctx.formId);
      if (f) return f;
    }
    if (ctx.productInfo) {
      const f = ctx.productInfo.querySelector('form[is="product-form"]');
      if (f) return f;
    }
    return document.querySelector('form[is="product-form"][data-type="add-to-cart-form"]');
  }

  function isMainProductForm(form) {
    if (!form) return false;
    const main = getProductForm();
    return main ? form === main : form.getAttribute('data-type') === 'add-to-cart-form';
  }

  function getQuantityInput() {
    const form = getProductForm();
    if (form) {
      const inForm = form.querySelector('input[name="quantity"]');
      if (inForm) return inForm;
      if (form.id) {
        const byAttr = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
        if (byAttr) return byAttr;
      }
    }
    if (ctx.productInfo) {
      const inInfo = ctx.productInfo.querySelector('input[name="quantity"]');
      if (inInfo) return inInfo;
    }
    return document.querySelector('input[name="quantity"]');
  }

  function getSelectedVariant() {
    const form = getProductForm();
    const input = form ? form.querySelector('input[name="id"], select[name="id"]') : document.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    const info = getInfo();
    return info.selectedVariantId ? String(info.selectedVariantId) : null;
  }

  function getPriceAnchor() {
    if (ctx.sectionId && ctx.productId) {
      const priceBox = document.getElementById('Price-' + ctx.sectionId + '-' + ctx.productId);
      if (priceBox) return priceBox.closest('.product__price') || priceBox;
    }
    const pi = ctx.productInfo || document.querySelector('product-info');
    if (pi) {
      const pp = pi.querySelector('.product__price');
      if (pp) return pp;
    }
    return null;
  }

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        const fmt = (theme.settings && theme.settings.moneyFormat) || getInfo().moneyFormat || '';
        return theme.Currency.formatMoney(cents, fmt);
      }
    } catch (e) { /* fallback aşağıda */ }
    const format = getInfo().moneyFormat || '{{amount}}';
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    let precision = 2, thousands = ',', decimal = '.';
    if (key.indexOf('no_decimals') !== -1) precision = 0;
    if (key.indexOf('with_comma_separator') !== -1) { thousands = '.'; decimal = ','; }
    else if (key.indexOf('with_space_separator') !== -1) { thousands = ' '; decimal = '.'; }
    else if (key.indexOf('with_apostrophe_separator') !== -1) { thousands = "'"; decimal = '.'; }
    const num = (Number(cents) / 100).toFixed(precision);
    const parts = num.split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const value = parts[0] + (parts[1] ? decimal + parts[1] : '');
    return m ? format.replace(m[0], value) : value;
  }

  function initializeMultiplier() {
    if (!window.productVariantInfo) {
      logError('Product variant info not found');
      return false;
    }

    const info = window.productVariantInfo;
    allSizeVariants = (info.allSizeVariantIds || []).map(String);
    minStockQuantity = info.minStockQuantity || 0;
    availableSizes = (info.allSizes || []).map(s => normalizeSize(s));
    currentPriceCents = Number(info.selectedVariantPrice) || 0;

    log('Product info loaded:', info.productTitle);

    if (allSizeVariants.length === 0) {
      logError('No size variants found');
      return false;
    }

    parseVariantStocks(info.sizeVariantStocks);

    if (info.isBedenSetiFormat && info.setDistribution &&
      (info.setDistribution.includes('|') || info.setDistribution.includes(','))) {
      isBedenSetiFormat = true;
      variantDistributions = parseVariantDistributions(info.setDistribution);
      log('Beden Seti format detected');
    } else if (info.setDistribution && info.setDistribution.includes('Paket Yapısı:')) {
      isPaketYapisiFormat = true;
      paketMultiplier = parsePaketYapisi(info.setDistribution);
      log('Paket Yapısı format detected, multiplier:', paketMultiplier);
    } else {
      isBedenSetiFormat = false;
      isPaketYapisiFormat = false;
      sizeDistribution = parseSetDistribution(info.setDistribution || 'AUTO');
      log('Traditional format detected');
    }

    if (isBedenSetiFormat) {
      if (Object.keys(variantDistributions).length === 0) {
        logError('Could not parse variant distributions');
        return false;
      }
    } else {
      if (Object.keys(sizeDistribution).length === 0) {
        logError('Could not parse size distribution');
        return false;
      }
    }

    resolveContext();
    log('Set Multiplier initialized successfully', ctx);

    moveSetInfoToCorrectPosition();
    updateSetInfoDisplay();

    return true;
  }

  function parseVariantStocks(stockString) {
    if (!stockString) return;

    const stockPairs = stockString.split(',');
    stockPairs.forEach(pair => {
      const parts = pair.split(':');
      if (parts.length === 2) {
        const variantId = parts[0];
        const stockAndSize = parts[1].split('|');

        if (stockAndSize.length === 2) {
          const stock = parseInt(stockAndSize[0]) || 0;
          const sizeName = stockAndSize[1];
          sizeVariantStocks[variantId] = { stock, sizeName };
        }
      }
    });
  }

  // Optimize edilmiş string temizleme helper fonksiyonu
  function cleanupDistributionText(text) {
    if (!text) return '';
    return text.toString()
      .replace(/<[^>]*>/g, '')
      .replace(/&[a-zA-Z0-9#]+;/g, '')
      .replace(/\*+/g, '')
      .replace(/[\r\n\t\f\v]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseSetDistribution(distributionText) {
    if (!distributionText) return {};

    const distribution = {};
    const cleanText = cleanupDistributionText(distributionText);

    log('Parsing distribution text:', cleanText);

    // STD formatını öncelikli olarak kontrol et
    // Pattern 1: "STD-5" formatı
    let stdMatch = cleanText.match(/STD-(\d+)/i) || cleanText.match(/STD\s*[-:]\s*(\d+)/i);
    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log(`STD format detected: STD-${multiplier}`);
      distribution['STD'] = multiplier;
      return distribution;
    }

    // Pattern 2: "5xSTANDART" veya "6xSTANDART" formatı
    stdMatch = cleanText.match(/(\d+)\s*x\s*STANDART/i) ||
      cleanText.match(/(\d+)\s*x\s*STD/i) ||
      cleanText.match(/(\d+)xSTANDART/i) ||
      cleanText.match(/(\d+)xSTD/i);

    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log(`xSTANDART format detected: ${multiplier}xSTANDART`);
      distribution['STD'] = multiplier;
      return distribution;
    }

    // Pattern 3: Sadece sayı ile STANDART kelimesi
    stdMatch = cleanText.match(/(\d+)\s+STANDART/i) ||
      cleanText.match(/STANDART\s+(\d+)/i);

    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log(`STANDART number format detected: ${multiplier} STANDART`);
      distribution['STD'] = multiplier;
      return distribution;
    }

    // OPTIMIZE EDİLMİŞ: İki pattern'i birleştir
    const excludedWords = new Set(['TRY', 'USD', 'EUR', 'GBP', 'ADET', 'KG', 'TL', 'MAL', 'VE', 'BR', 'DIV', 'EM', 'TEK']);
    const validSizes = new Set(['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XS', '2XL', '3XL', '4XL', '5XL', '6XL']);

    // YENİ: Kolon formatı - "S:1 M:1 L:1 XL:1 XXL:1" (Romence/Türkçe set bilgisi)
    const colonPattern = /([A-Z]{1,4}|\d{2,3})\s*:\s*(\d+)/gi;
    const colonMatches = [...cleanText.matchAll(colonPattern)];

    if (colonMatches.length > 0) {
      log('Colon format detected');
      for (const match of colonMatches) {
        const sizeName = match[1].toUpperCase();
        const quantity = parseInt(match[2]);
        const isNumericSize = /^\d{2,3}$/.test(sizeName);
        if ((isNumericSize || (validSizes.has(sizeName) && !excludedWords.has(sizeName))) && quantity > 0 && quantity <= 100) {
          distribution[sizeName] = quantity;
          log(`Found colon format: ${sizeName}:${quantity}`);
        }
      }

      if (Object.keys(distribution).length > 0) {
        log('Distribution from colon format:', distribution);
        return distribution;
      }
    }

    // (toserof) Bitişik rakam-önekli beden formatı - "3XL2-4XL1-5XL1-6XL1" (3XL=beden, 2=adet)
    // ERKEN denenir: yoksa "quantity-size" deseni "3XL2"yi yanlış ("3"+"XL") parse eder.
    {
      const dpMatches = [...cleanText.matchAll(/(\d+XL)(\d+)/gi)];
      for (const m of dpMatches) {
        const size = m[1].toUpperCase();
        const quantity = parseInt(m[2]);
        if (validSizes.has(size) && quantity > 0 && quantity <= 100) {
          distribution[size] = quantity;
          log(`Found digit-prefixed size: ${size}${quantity}`);
        }
      }
      if (Object.keys(distribution).length > 0) {
        log('Distribution from digit-prefixed format:', distribution);
        return distribution;
      }
    }

    // YENİ: Parantez formatı - "(S-M)-3" veya "(S-M):3"
    const parenthesisPattern = /\(([A-Z]+(?:-[A-Z]+)*)\)\s*[-:=]\s*(\d+)/gi;
    const parenthesisMatches = [...cleanText.matchAll(parenthesisPattern)];

    if (parenthesisMatches.length > 0) {
      log('Parenthesis format detected');
      for (const match of parenthesisMatches) {
        const sizeName = match[1].toUpperCase();
        const quantity = parseInt(match[2]);
        if (quantity > 0 && quantity <= 100) {
          distribution[sizeName] = quantity;
          log(`Found parenthesis format: (${sizeName})-${quantity}`);
        }
      }

      if (Object.keys(distribution).length > 0) {
        log('Distribution from parenthesis format:', distribution);
        return distribution;
      }
    }

    // YENİ: Tire içeren beden isimleri - "S-M-3" veya "L-XL:2"
    // Önce tire içeren beden isimlerini kontrol et (availableSizes'dan gelecek)
    if (window.productVariantInfo && window.productVariantInfo.allSizes) {
      const availableSizeNames = window.productVariantInfo.allSizes.map(s => s.toUpperCase());
      log('Checking compound size names:', availableSizeNames);

      // Tire içeren beden isimleri varsa onları dene
      for (const sizeName of availableSizeNames) {
        if (sizeName.includes('-')) {
          // "S-M" gibi tire içeren beden için pattern: "S-M-3" veya "S-M:3"
          const escapedSize = sizeName.replace(/-/g, '\\-');
          const compoundPattern = new RegExp(`(${escapedSize})\\s*[-:=]\\s*(\\d+)`, 'gi');
          const compoundMatch = cleanText.match(compoundPattern);

          if (compoundMatch) {
            const qtyMatch = compoundMatch[0].match(/(\d+)$/);
            if (qtyMatch) {
              const quantity = parseInt(qtyMatch[1]);
              if (quantity > 0 && quantity <= 100) {
                distribution[sizeName] = quantity;
                log(`Found compound size: ${sizeName}-${quantity}`);
              }
            }
          }
        }
      }

      if (Object.keys(distribution).length > 0) {
        log('Distribution from compound size names:', distribution);
        return distribution;
      }
    }

    // Önce "2S" gibi quantity-size formatını dene - SADECE GEÇERLİ BEDENLER
    const quantitySizeMatches = cleanText.matchAll(/(\d+)([A-Z]{1,4})/g);
    for (const match of quantitySizeMatches) {
      const quantity = parseInt(match[1]);
      const size = match[2].toUpperCase();
      // SADECE bilinen beden isimleri kabul et
      if (validSizes.has(size) && !excludedWords.has(size) && quantity > 0 && quantity <= 100) {
        distribution[size] = quantity;
        log(`Found quantity-size: ${quantity}${size}`);
      } else {
        log(`Skipped invalid size: ${size} from ${quantity}${size}`);
      }
    }

    if (Object.keys(distribution).length > 0) {
      log('Distribution from quantity-size format:', distribution);
      return distribution;
    }

    // Sonra "S-2" gibi size-quantity formatını dene - GEÇERLİ BEDENLER + NUMERIC
    const sizeQuantityMatches = cleanText.matchAll(/([A-Z]{1,4}|\d{2,3})\s*-\s*(\d{1,2})/gi);
    for (const match of sizeQuantityMatches) {
      const size = match[1].toUpperCase();
      const quantity = parseInt(match[2]);
      const isNumericSize = /^\d{2,3}$/.test(size);
      // Harf bedenler: validSizes kontrolü, Numeric bedenler: direkt kabul
      if ((isNumericSize || (validSizes.has(size) && !excludedWords.has(size))) && quantity > 0 && quantity <= 100) {
        distribution[size] = quantity;
        log(`Found size-quantity: ${size}-${quantity}`);
      } else {
        log(`Skipped invalid size: ${size} from ${size}-${quantity}`);
      }
    }

    if (Object.keys(distribution).length > 0) {
      log('Distribution from size-quantity format:', distribution);
      return distribution;
    }

    // OPTIMIZE EDİLMİŞ: Manual parsing - sadece başarısızlık durumunda
    const parts = cleanText.split(/[\s\-]+/);
    log('Manual parsing parts:', parts);

    for (const part of parts) {
      if (!part) continue;

      // "2S" formatı - SADECE GEÇERLİ BEDENLER
      let match = part.match(/^(\d+)([A-Z]{1,4})$/i);
      if (match) {
        const quantity = parseInt(match[1]);
        const size = match[2].toUpperCase();
        if (validSizes.has(size) && !excludedWords.has(size) && quantity > 0 && quantity <= 100) {
          distribution[size] = quantity;
          log(`Manual quantity-size: ${size} = ${quantity}`);
        }
        continue;
      }

      // "M1" veya "XL2" formatı - beden+adet yapışık
      match = part.match(/^([A-Z]{1,4})(\d{1,2})$/i);
      if (match) {
        const size = match[1].toUpperCase();
        const quantity = parseInt(match[2]);
        const isValid = validSizes.has(size) && !excludedWords.has(size) && quantity > 0 && quantity <= 100;
        if (isValid) {
          distribution[size] = quantity;
          log(`Manual concat size-qty: ${size} = ${quantity}`);
        }
        continue;
      }

      // "S-2" veya "44-2" formatı - GEÇERLİ BEDENLER + NUMERIC
      match = part.match(/^([A-Z]{1,4}|\d{2,3})-(\d{1,2})$/i);
      if (match) {
        const size = match[1].toUpperCase();
        const quantity = parseInt(match[2]);
        const isNumericSize = /^\d{2,3}$/.test(size);
        if ((isNumericSize || (validSizes.has(size) && !excludedWords.has(size))) && quantity > 0 && quantity <= 100) {
          distribution[size] = quantity;
          log(`Manual size-quantity: ${size} = ${quantity}`);
        }
      }
    }

    // AUTO mode - sadece hiçbir şey bulunamazsa
    if (Object.keys(distribution).length === 0 && availableSizes.length > 0) {
      log('No distribution found, using AUTO mode');
      for (const size of availableSizes) {
        const normalizedSize = size.toUpperCase();
        // AUTO mode'da da sadece geçerli bedenleri kabul et
        if (!excludedWords.has(normalizedSize) && validSizes.has(normalizedSize)) {
          distribution[normalizedSize] = 1;
          log(`AUTO: ${normalizedSize} = 1`);
        }
      }
    }

    log('Final distribution:', distribution);
    return distribution;
  }

  function parseVariantDistributions(distributionText) {
    const distributions = {};

    if (!distributionText) return distributions;

    const pairs = distributionText.split(',');

    pairs.forEach(pair => {
      const parts = pair.split('|');
      if (parts.length === 2) {
        const range = parts[0].trim();
        const multiplier = parseInt(parts[1]) || 1;
        distributions[range] = multiplier;
      }
    });

    return distributions;
  }

  function parsePaketYapisi(distributionText) {
    if (!distributionText) return 1;

    const cleanText = cleanupDistributionText(distributionText);
    log('Parsing Paket Yapısı text:', cleanText);

    // "Paket Yapısı: 1S+1M+1L+1XL" formatını parse et
    const paketMatch = cleanText.match(/Paket Yapısı:\s*(.+)/i);
    if (paketMatch) {
      const paketContent = paketMatch[1];
      // '+' ile ayrılmış kısımları say
      const parts = paketContent.split('+');
      const multiplier = parts.length;
      log(`Paket Yapısı detected: ${paketContent} -> multiplier: ${multiplier}`);
      return multiplier;
    }

    return 1;
  }

  // STD format için özel stok kontrolü
  function calculateMaxSetsForSTD(stdMultiplier) {
    // STD formatında tek bir variant var, ilk variant'ı kullan
    if (allSizeVariants.length === 0) {
      return {
        maxSets: 0,
        limitingFactor: 'Variant bulunamadı',
        stockDetails: {},
        missingVariants: []
      };
    }

    const variantId = allSizeVariants[0];
    const stockInfo = sizeVariantStocks[variantId];

    if (!stockInfo) {
      return {
        maxSets: 0,
        limitingFactor: 'Stok bilgisi bulunamadı',
        stockDetails: {},
        missingVariants: []
      };
    }

    const availableStock = stockInfo.stock || 0;
    const maxSets = Math.floor(availableStock / stdMultiplier);

    log(`STD Stock Check: ${availableStock} stok / ${stdMultiplier} multiplier = ${maxSets} maksimum set`);

    return {
      maxSets: maxSets,
      limitingFactor: `${availableStock} stok / ${stdMultiplier} multiplier`,
      stockDetails: {
        'STD': {
          required: stdMultiplier,
          available: availableStock,
          variantId: variantId
        }
      },
      missingVariants: []
    };
  }

  // Darboğaz stok kontrolü fonksiyonu
  function calculateMaxSetsFromStock(distribution) {
    const isSTDFormat = Object.keys(distribution).length === 1 && Object.keys(distribution)[0] === 'STD';

    if (isSTDFormat) {
      const stdMultiplier = distribution['STD'];
      return calculateMaxSetsForSTD(stdMultiplier);
    }

    let maxSets = Infinity;
    const stockDetails = {};

    for (const [size, requiredQty] of Object.entries(distribution)) {
      const variantId = findVariantIdBySize(size);

      if (!variantId) {
        log(`Variant not found for size: ${size}`);
        return {
          maxSets: 0,
          limitingFactor: `${size} bedeni bulunamadı`,
          stockDetails: {},
          missingVariants: [size]
        };
      }

      const stockInfo = sizeVariantStocks[variantId];
      const availableStock = stockInfo ? stockInfo.stock : 0;

      stockDetails[size] = {
        required: requiredQty,
        available: availableStock,
        variantId: variantId
      };

      const possibleSets = Math.floor(availableStock / requiredQty);

      if (possibleSets < maxSets) {
        maxSets = possibleSets;
      }

      log(`Size ${size}: ${availableStock} stok / ${requiredQty} gerekli = ${possibleSets} set`);
    }

    const limitingSize = Object.entries(stockDetails).find(([size, info]) =>
      Math.floor(info.available / info.required) === maxSets
    );

    return {
      maxSets: maxSets === Infinity ? 0 : maxSets,
      limitingFactor: limitingSize ? `${limitingSize[0]} bedeni (${limitingSize[1].available} stok)` : 'Bilinmeyen',
      stockDetails: stockDetails,
      missingVariants: []
    };
  }

  // Eksik varyant kontrolü
  function checkMissingVariants(distribution) {
    const missingVariants = [];

    for (const size of Object.keys(distribution)) {
      const variantId = findVariantIdBySize(size);
      if (!variantId) {
        missingVariants.push(size);
      }
    }

    return missingVariants;
  }

  // Set bütünlüğü kontrolü
  function validateSetIntegrity(userQuantity, distribution) {
    const stockAnalysis = calculateMaxSetsFromStock(distribution);
    const missingVariants = checkMissingVariants(distribution);

    const result = {
      isValid: true,
      maxPossibleSets: stockAnalysis.maxSets,
      requestedSets: userQuantity,
      canFulfill: userQuantity <= stockAnalysis.maxSets,
      missingVariants: missingVariants,
      limitingFactor: stockAnalysis.limitingFactor,
      stockDetails: stockAnalysis.stockDetails,
      errors: []
    };

    // Eksik varyant kontrolü
    if (missingVariants.length > 0) {
      result.isValid = false;
      result.errors.push(t('missingSizesErr', { sizes: missingVariants.join(', ') }));
    }

    // Stok yetersizliği kontrolü
    if (userQuantity > stockAnalysis.maxSets) {
      result.isValid = false;
      result.errors.push(t('insufficientStockMaxSetsErr', { max: stockAnalysis.maxSets, factor: stockAnalysis.limitingFactor }));
    }

    log('Set Integrity Check:', result);
    return result;
  }

  // ============================================================
  // ADET SINIRLAMA (Concept quantity-input ile uyumlu)
  // ============================================================
  function currentMaxSets() {
    if (isBedenSetiFormat) {
      const selectedVariant = getSelectedVariant();
      if (!selectedVariant) return null;
      const variantSize = getVariantSize(selectedVariant);
      let multiplier = 1;
      for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
        if (isSizeInRange(variantSize, range)) {
          multiplier = rangeMultiplier;
          break;
        }
      }
      const stockInfo = sizeVariantStocks[selectedVariant];
      return stockInfo ? Math.floor(stockInfo.stock / multiplier) : 0;
    }
    if (isPaketYapisiFormat) {
      if (allSizeVariants.length === 0) return null;
      const stockInfo = sizeVariantStocks[allSizeVariants[0]];
      return stockInfo ? Math.floor(stockInfo.stock / paketMultiplier) : 0;
    }
    const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';
    if (isSTDFormat) {
      return calculateMaxSetsForSTD(sizeDistribution['STD']).maxSets;
    }
    return calculateMaxSetsFromStock(sizeDistribution).maxSets;
  }

  function limitQuantityInputs() {
    const maxSets = currentMaxSets();
    if (maxSets === null || maxSets === undefined) return;
    setQuantityInputLimits(maxSets);
  }

  function setQuantityInputLimits(maxValue) {
    const input = getQuantityInput();
    if (!input) return;

    input.setAttribute('data-yk-max', String(maxValue));

    if (maxValue === 0) {
      input.value = 0;
      input.disabled = true;
      input.setAttribute('max', '0');
      input.style.backgroundColor = '#f5f5f5';
      input.style.color = '#999';
    } else {
      input.disabled = false;
      input.style.backgroundColor = '';
      input.style.color = '';
      input.setAttribute('max', String(maxValue));

      const currentValue = parseInt(input.value) || 1;
      if (currentValue > maxValue) {
        input.value = Math.max(1, maxValue);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (currentValue < 1) {
        input.value = 1;
      }

      if (!input.dataset.ykGuard) {
        input.dataset.ykGuard = '1';

        input.addEventListener('keydown', function (e) {
          const max = parseInt(this.getAttribute('data-yk-max'));
          if (isNaN(max)) return;
          if ((e.key === 'ArrowUp' || e.key === 'PageUp') && parseInt(this.value) >= max) {
            e.preventDefault();
            showQuantityLimitWarning(max);
            return false;
          }
          if ((e.key === 'ArrowDown' || e.key === 'PageDown') && parseInt(this.value) <= 1) {
            e.preventDefault();
            return false;
          }
        });

        input.addEventListener('wheel', function (e) {
          const max = parseInt(this.getAttribute('data-yk-max'));
          if (isNaN(max)) return;
          if (e.deltaY < 0 && parseInt(this.value) >= max) {
            e.preventDefault();
            showQuantityLimitWarning(max);
            return false;
          }
        }, { passive: false });

        input.addEventListener('input', function () {
          const max = parseInt(this.getAttribute('data-yk-max'));
          if (isNaN(max) || max === 0) return;
          let value = parseInt(this.value);
          if (isNaN(value) || value < 1) {
            this.value = 1;
          } else if (value > max) {
            this.value = max;
            showQuantityLimitWarning(max);
          }
        });
      }
    }

    updateQuantityButtons(maxValue);

    log(`Quantity inputs limited to maximum: ${maxValue} sets`);
  }

  function updateQuantityButtons(maxValue) {
    const input = getQuantityInput();
    const qi = input ? input.closest('quantity-input') : null;
    if (!qi) return;

    const currentQuantity = parseInt(input.value) || 1;
    const plus = qi.querySelector('button[name="plus"]');
    const minus = qi.querySelector('button[name="minus"]');

    if (plus) {
      const off = maxValue === 0 || currentQuantity >= maxValue;
      plus.toggleAttribute('disabled', off);
      plus.title = off ? t('maxSetsOnlyWarn', { max: maxValue }) : '';
    }
    if (minus) {
      minus.toggleAttribute('disabled', maxValue === 0 || currentQuantity <= 1);
    }
  }

  // Sınır uyarısı göster
  function showQuantityLimitWarning(maxValue) {
    const existingWarning = document.querySelector('.quantity-limit-warning');
    if (existingWarning) {
      existingWarning.remove();
    }

    const warning = document.createElement('div');
    warning.className = 'quantity-limit-warning';
    warning.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
      color: white;
      padding: 12px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
      z-index: 99999;
      animation: slideInShake 0.5s ease-out;
      font-size: 14px;
      font-weight: 500;
      max-width: 300px;
      display: flex;
      align-items: center;
      gap: 10px;
    `;

    const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';
    let message;

    if (maxValue === 0) {
      if (isPaketYapisiFormat) {
        message = t('pkgInsufficientWarn');
      } else if (isSTDFormat) {
        message = t('stdInsufficientWarn');
      } else {
        message = t('setIntegrityWarn');
      }
    } else {
      let multiplier = 1;
      if (isPaketYapisiFormat) {
        multiplier = paketMultiplier;
      } else if (isSTDFormat) {
        multiplier = sizeDistribution['STD'];
      }
      const totalItems = maxValue * multiplier;
      const formatType = isPaketYapisiFormat ? t('pkgUnit') : t('setUnit');
      message = t('maxAddableWarn', { max: maxValue, format: formatType, total: totalItems });
    }

    warning.innerHTML = `
      <span style="font-size: 18px;">⚠️</span>
      <span>${message}</span>
    `;

    document.body.appendChild(warning);

    setTimeout(() => {
      if (warning.parentNode) {
        warning.style.animation = 'slideOutShake 0.3s ease-in';
        setTimeout(() => warning.remove(), 300);
      }
    }, 3000);
  }

  // ============================================================
  // SET TOPLAM FİYATI + SEPETE-EKLENİYOR BEKLETME
  // Ana/varyant fiyatı BİRİM (tane başı) fiyatıdır. Set eklenince N parça
  // sepete girer; bu yüzden fiyatın ALTINA "Set toplamı = birim × N" yazılır.
  // ============================================================
  function stCurrentPiecesPerSet() {
    try {
      if (isBedenSetiFormat) {
        const sv = getSelectedVariant();
        if (!sv) return 0;
        const size = getVariantSize(sv);
        for (const [range, mult] of Object.entries(variantDistributions)) {
          if (isSizeInRange(size, range)) return mult;
        }
        return 0;
      }
      if (isPaketYapisiFormat) return paketMultiplier || 0;
      return Object.values(sizeDistribution).reduce((s, q) => s + q, 0) || 0;
    } catch (e) { return 0; }
  }

  function stEnsureTotalEl() {
    let el = document.getElementById('setTotalPrice');
    if (!el) {
      el = document.createElement('div');
      el.id = 'setTotalPrice';
      el.className = 'set-total-price';
    }
    return el;
  }

  function updateSetTotalPrice() {
    try {
      const el = document.getElementById('setTotalPrice');
      if (!el) return;
      const pieces = stCurrentPiecesPerSet();
      if (!pieces || pieces <= 1 || !currentPriceCents) { el.style.display = 'none'; return; }
      const total = currentPriceCents * pieces;
      el.style.display = '';
      el.innerHTML =
        `<span class="set-total-price__label">${t('setTotalLabel')}</span> ` +
        `<span class="set-total-price__value">${formatMoney(total)}</span> ` +
        `<span class="set-total-price__note">${formatMoney(currentPriceCents)} ${t('unitPriceNote')} × ${pieces} ${t('pcsUnit')}</span>`;
    } catch (e) { log('updateSetTotalPrice error: ' + e.message); }
  }

  // Sepete eklenirken bilgi şeridiyle müşteriyi bekletme (buton spinner'ı temanın kendisinden gelir)
  function stSetAddLoading(on) {
    try {
      let n = document.getElementById('stAddingNotice');
      if (on) {
        if (!n) {
          n = document.createElement('div');
          n.id = 'stAddingNotice';
          n.className = 'st-adding-notice';
          n.setAttribute('role', 'status');
          n.innerHTML = `<span class="st-adding-spinner"></span><span>${t('addingToCartOverlay')}</span>`;
          const form = getProductForm();
          const host = (form && form.querySelector('.product-form__buttons')) || form || document.body;
          host.appendChild(n);
        }
        n.style.display = 'flex';
      } else if (n) { n.style.display = 'none'; }
    } catch (e) { log('stSetAddLoading error: ' + e.message); }
  }

  function moveSetInfoToCorrectPosition() {
    const setInfoElement = document.getElementById('setMultiplierInfo');
    if (!setInfoElement) {
      log('Set info element not found, will be created later');
      return;
    }

    const totalEl = stEnsureTotalEl();
    const anchor = getPriceAnchor();

    if (anchor) {
      anchor.insertAdjacentElement('afterend', totalEl);
      totalEl.insertAdjacentElement('afterend', setInfoElement);
      log('Set info moved after product price block');
    } else {
      const wrapper = document.querySelector('.product-form-wrapper');
      if (wrapper && wrapper.parentNode) {
        wrapper.parentNode.insertBefore(totalEl, wrapper);
        wrapper.parentNode.insertBefore(setInfoElement, wrapper);
        log('Price block not found, set info placed before product form');
      } else {
        const pi = ctx.productInfo || document.querySelector('product-info');
        if (pi) { pi.appendChild(totalEl); pi.appendChild(setInfoElement); }
        log('Set info appended to product-info');
      }
    }

    updateSetTotalPrice();
  }

  function updateSetInfoDisplay() {
    const setInfoText = document.getElementById('setInfoText');
    const setInfoDetails = document.getElementById('setInfoDetails');

    if (!setInfoText || !setInfoDetails) return;

    if (isBedenSetiFormat) {
      setInfoText.innerHTML = `<strong>${t('bedenSetiTitle')}</strong> ${t('bedenSetiAutoDesc')}`;

      let detailsHtml = '<div style="margin-top: 5px;">';
      for (const [range, multiplier] of Object.entries(variantDistributions)) {
        detailsHtml += `<div style="margin: 2px 0;">${t('rangeNotice', { range: range, qty: multiplier })}</div>`;
      }
      detailsHtml += '</div>';
      setInfoDetails.innerHTML = detailsHtml;

    }
    else if (isPaketYapisiFormat) {
      setInfoText.innerHTML = `<strong>${t('paketTitle')}</strong> ${t('paketDescription', { qty: paketMultiplier })}`;
      setInfoDetails.innerHTML = `<div style="margin-top: 5px; color: #666;"><small>${t('paketSubtitle')}</small></div>`;
    }
    else {
      const totalItems = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);

      const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

      if (isSTDFormat) {
        setInfoText.innerHTML = `<strong>${t('setTitle')}</strong> ${t('setStdDescription', { qty: totalItems })}`;
        setInfoDetails.innerHTML = `<div style="margin-top: 5px; color: #666;"><small>${t('setSubtitle')}</small></div>`;
      } else {
        const stockAnalysis = calculateMaxSetsFromStock(sizeDistribution);

        setInfoText.innerHTML = `<strong>${t('setTitle')}</strong> ${t('setMultiDescription', { qty: totalItems })}`;

        let detailsHtml = `<div style="margin-top: 5px;"><strong>${t('distributionLabel')}</strong> `;
        const distributionParts = [];
        for (const [size, qty] of Object.entries(sizeDistribution)) {
          distributionParts.push(`${size} (${qty} ${t('pcsUnit')})`);
        }
        detailsHtml += distributionParts.join(', ') + '</div>';

        detailsHtml += `<div style="margin-top: 8px; padding: 6px; background: #e8f5e8; border-radius: 4px; border-left: 3px solid #4caf50;">
          <strong>${t('maxAddableLabel')}</strong> ${stockAnalysis.maxSets} ${t('setUnit')}
          ${stockAnalysis.maxSets > 0 ? `<br><small>${t('limitingFactorLabel')} ${stockAnalysis.limitingFactor}</small>` : ''}
        </div>`;

        setInfoDetails.innerHTML = detailsHtml;
      }
    }
  }

  function getCurrentQuantity() {
    const input = getQuantityInput();
    if (input && input.value) {
      const value = parseInt(input.value) || 1;
      log(`Found quantity input = ${value}`);
      return Math.max(1, value);
    }
    log('No quantity input found, defaulting to 1');
    return 1;
  }

  function updateSetInfoOnQuantityChange(quantity) {
    const setInfoDetails = document.getElementById('setInfoDetails');
    if (!setInfoDetails) return;

    quantity = Math.max(1, parseInt(quantity) || 1);

    limitQuantityInputs();

    if (isBedenSetiFormat) {
      const selectedVariant = getSelectedVariant();
      if (selectedVariant) {
        const variantSize = getVariantSize(selectedVariant);
        let selectedRange = null;
        let multiplier = 1;

        for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
          if (isSizeInRange(variantSize, range)) {
            selectedRange = range;
            multiplier = rangeMultiplier;
            break;
          }
        }

        if (selectedRange) {
          const finalQuantity = quantity * multiplier;
          const stockInfo = sizeVariantStocks[selectedVariant];
          const maxSets = stockInfo ? Math.floor(stockInfo.stock / multiplier) : 0;

          setInfoDetails.innerHTML = `<div style="margin-top: 5px; padding: 8px; background: #e8f4f8; border-radius: 4px; border: 1px solid #007cba;">
            <strong>${t('yourSelectionLabel')}</strong> ${selectedRange} → ${quantity} × ${multiplier} = <span style="color: #007cba; font-weight: bold;">${finalQuantity} ${t('pcsUnit')}</span>
            <div style="margin-top: 4px; font-size: 12px; color: #666;">
              ${t('maxAddableLabel')} ${maxSets} ${t('setUnit')} (${maxSets * multiplier} ${t('pcsUnit')})
            </div>
          </div>`;
        }
      }
    }
    else if (isPaketYapisiFormat) {
      const finalTotal = quantity * paketMultiplier;
      const variantId = allSizeVariants[0];
      const stockInfo = sizeVariantStocks[variantId];
      const maxSets = stockInfo ? Math.floor(stockInfo.stock / paketMultiplier) : 0;

      setInfoDetails.innerHTML = `<div style="margin-top: 5px; padding: 8px; background: #e8f4f8; border-radius: 4px; border: 1px solid #007cba;">
    <strong>${t('addingToCartLabel')}</strong> ${quantity} ${t('pkgUnit')} × ${paketMultiplier} = <span style="color: #007cba; font-weight: bold;">${finalTotal} ${t('pcsUnit')}</span>
    <div style="margin-top: 4px; font-size: 12px; color: #666;">
      ${t('maxAddableLabel')} ${maxSets} ${t('pkgUnitPlural')} (${maxSets * paketMultiplier} ${t('pcsUnit')})
    </div>
  </div>`;
    }
    else {
      const totalPerSet = Object.values(sizeDistribution).reduce((sum, qty) => sum + qty, 0);
      const finalTotal = quantity * totalPerSet;

      const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

      if (isSTDFormat) {
        const stdQuantity = sizeDistribution['STD'];
        const variantId = allSizeVariants[0];
        const stockInfo = sizeVariantStocks[variantId];
        const maxSets = stockInfo ? Math.floor(stockInfo.stock / stdQuantity) : 0;

        setInfoDetails.innerHTML = `<div style="margin-top: 5px; padding: 8px; background: #e8f4f8; border-radius: 4px; border: 1px solid #007cba;">
          <strong>${t('addingToCartLabel')}</strong> ${quantity} ${t('pcsUnit')} × ${totalPerSet} = <span style="color: #007cba; font-weight: bold;">${finalTotal} ${t('pcsUnit')}</span>
          <div style="margin-top: 4px; font-size: 12px; color: #666;">
            ${t('maxAddableLabel')} ${maxSets} ${t('setUnit')} (${maxSets * totalPerSet} ${t('pcsUnit')})
          </div>
        </div>`;
      } else {
        const validation = validateSetIntegrity(quantity, sizeDistribution);

        let detailsHtml = `<div style="margin-top: 5px; padding: 8px; background: ${validation.isValid ? '#e8f4f8' : '#ffe8e8'}; border-radius: 4px; border: 1px solid ${validation.isValid ? '#007cba' : '#ff6b6b'};">`;

        if (validation.isValid) {
          detailsHtml += `<strong>${t('addingToCartLabel')}</strong> ${quantity} ${t('setUnit')} × ${totalPerSet} ${t('pcsUnit')} = <span style="color: #007cba; font-weight: bold;">${finalTotal} ${t('pcsUnit')}</span><br>
            <small style="color: #666;">${t('detailsLabel')} `;

          const details = [];
          for (const [size, qty] of Object.entries(sizeDistribution)) {
            const sizeTotal = qty * quantity;
            details.push(`${size}: ${sizeTotal} ${t('pcsUnit')}`);
          }
          detailsHtml += details.join(', ') + '</small>';

          detailsHtml += `<br><small style="color: #666; margin-top: 4px; display: block;">
            ${t('maxAddableLabel')} ${validation.maxPossibleSets} ${t('setUnit')} (${validation.maxPossibleSets * totalPerSet} ${t('pcsUnit')})
          </small>`;
        } else {
          detailsHtml += `<strong style="color: #ff6b6b;">${t('cantAddTitle')}</strong><br>`;
          validation.errors.forEach(error => {
            detailsHtml += `<small style="color: #ff6b6b;">• ${error}</small><br>`;
          });
          detailsHtml += `<small style="color: #666;">${t('maxAddableLabel')} ${validation.maxPossibleSets} ${t('setUnit')}</small>`;
        }

        detailsHtml += '</div>';
        setInfoDetails.innerHTML = detailsHtml;
      }
    }

    updateSetTotalPrice();
  }

  // ============================================================
  // OLAY BAĞLAMA (adet input'u, varyant değişimi)
  // ============================================================
  let pubsubBound = false;

  function bindQuantityInput() {
    const input = getQuantityInput();
    if (!input || input.dataset.ykBound) return;
    input.dataset.ykBound = '1';

    ['input', 'change', 'keyup', 'blur'].forEach(eventType => {
      input.addEventListener(eventType, (e) => {
        debounce('quantityChange', () => {
          let quantity = parseInt(e.target.value) || 1;

          const maxValue = parseInt(e.target.getAttribute('data-yk-max'));
          if (!isNaN(maxValue) && maxValue > 0 && quantity > maxValue) {
            quantity = maxValue;
            e.target.value = maxValue;
            showQuantityLimitWarning(maxValue);
          }

          if (quantity < 1 && maxValue !== 0) {
            quantity = 1;
            e.target.value = 1;
          }

          log(`Quantity changed via ${eventType}: ${quantity}`);
          updateSetInfoOnQuantityChange(quantity);
        }, 200);
      });
    });
  }

  function onVariantChanged(variant) {
    if (variant && variant.price !== undefined && variant.price !== null) {
      currentPriceCents = Number(variant.price) || 0;
    }
    const currentQuantity = getCurrentQuantity();
    log(`Variant changed, updating with quantity: ${currentQuantity}`, variant && variant.id);
    limitQuantityInputs();
    updateSetInfoOnQuantityChange(currentQuantity);
    updateSetTotalPrice();
  }

  function setupQuantityListener() {
    bindQuantityInput();

    if (!pubsubBound && window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      pubsubBound = true;

      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
        const data = (event && event.data) || {};
        if (ctx.sectionId && data.sectionId && String(data.sectionId) !== String(ctx.sectionId)) return;
        if (ctx.productId && data.productId && String(data.productId) !== String(ctx.productId)) return;
        setTimeout(() => { bindQuantityInput(); onVariantChanged(data.variant); }, 30);
      });

      // Tema, varyant/sepet güncellemesinde input max'ını sıfırlar → sınırı yeniden uygula
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.quantityUpdate, () => {
        debounce('ykQuantityUpdate', () => { bindQuantityInput(); limitQuantityInputs(); }, 60);
      });
    }

    const form = getProductForm();
    if (form && !form.dataset.ykVariantBound) {
      form.dataset.ykVariantBound = '1';
      form.addEventListener('variant:change', (e) => {
        if (pubsubBound) return;
        onVariantChanged(e.detail && e.detail.variant);
      });
      form.addEventListener('change', (e) => {
        if (pubsubBound) return;
        if (e.target && e.target.name === 'id') onVariantChanged(null);
      });
    }

    setTimeout(() => {
      limitQuantityInputs();
    }, 100);
  }

  function normalizeSize(size) {
    return size.toString().toUpperCase().trim().replace(/[.\s]+$/, '');
  }

  function findVariantIdBySize(targetSize) {
    const normalizedTarget = normalizeSize(targetSize);
    log(`🔍 Searching for variant with size: "${targetSize}" (normalized: "${normalizedTarget}")`);

    if (normalizedTarget === 'STD') {
      if (allSizeVariants.length > 0) {
        log('✓ STD format: Using first available variant:', allSizeVariants[0]);
        return allSizeVariants[0];
      }
    }

    // Önce TAM EŞLEŞMEyE BAK - tire içeren beden isimleri için
    log('📦 Checking sizeVariantStocks:', Object.keys(sizeVariantStocks).length, 'variants');
    for (const variantId in sizeVariantStocks) {
      const sizeInfo = sizeVariantStocks[variantId];
      const sizeName = normalizeSize(sizeInfo.sizeName);
      log(`  - Variant ${variantId}: sizeName="${sizeInfo.sizeName}" (normalized: "${sizeName}")`);
      if (sizeName === normalizedTarget) {
        log(`✓ Found variant ${variantId} for size ${targetSize} (exact match)`);
        return variantId;
      }
    }

    // Sonra availableSizes'ta ara
    log('📋 Checking availableSizes:', availableSizes);
    for (let i = 0; i < availableSizes.length; i++) {
      const availableSize = normalizeSize(availableSizes[i]);
      log(`  - Index ${i}: "${availableSizes[i]}" (normalized: "${availableSize}")`);
      if (availableSize === normalizedTarget && i < allSizeVariants.length) {
        log(`✓ Found variant ${allSizeVariants[i]} for size ${targetSize} at index ${i} (exact match)`);
        return allSizeVariants[i];
      }
    }

    // YENİ: Kısmi eşleşme - tire içeren beden isimleri için
    // Örnek: "XL" arıyoruz, "L-XL" varyantını bulabiliriz
    log('🔍 Trying partial match for compound sizes...');
    for (const variantId in sizeVariantStocks) {
      const sizeInfo = sizeVariantStocks[variantId];
      const sizeName = normalizeSize(sizeInfo.sizeName);

      if (sizeName.includes('-')) {
        const sizeParts = sizeName.split('-').map(s => s.trim());
        log(`  - Checking compound size "${sizeName}": parts = [${sizeParts.join(', ')}]`);

        if (sizeParts.includes(normalizedTarget)) {
          log(`✓ Found variant ${variantId} for size ${targetSize} (partial match in "${sizeName}")`);
          return variantId;
        }
      }
    }

    for (let i = 0; i < availableSizes.length; i++) {
      const availableSize = normalizeSize(availableSizes[i]);

      if (availableSize.includes('-')) {
        const sizeParts = availableSize.split('-').map(s => s.trim());

        if (sizeParts.includes(normalizedTarget) && i < allSizeVariants.length) {
          log(`✓ Found variant ${allSizeVariants[i]} for size ${targetSize} at index ${i} (partial match in "${availableSize}")`);
          return allSizeVariants[i];
        }
      }
    }

    logError(`❌ Variant NOT found for size: "${targetSize}" (normalized: "${normalizedTarget}")`);
    logError('Available sizeVariantStocks keys:', Object.keys(sizeVariantStocks));
    logError('Available sizes:', availableSizes);
    return null;
  }

  function addQuantityLimitStyles() {
    if (document.querySelector('#quantity-limit-styles')) return;

    const style = document.createElement('style');
    style.id = 'quantity-limit-styles';
    style.textContent = `
      @keyframes slideInShake {
        0% { transform: translateX(100%) scale(0.8); opacity: 0; }
        50% { transform: translateX(-10px) scale(1.05); opacity: 1; }
        60% { transform: translateX(5px) scale(1.02); }
        70% { transform: translateX(-3px) scale(1.01); }
        100% { transform: translateX(0) scale(1); opacity: 1; }
      }
      @keyframes slideOutShake {
        0% { transform: translateX(0) scale(1); opacity: 1; }
        100% { transform: translateX(100%) scale(0.8); opacity: 0; }
      }

      .quantity-limit-warning {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
      }

      /* SET TOPLAM FİYATI (fiyat bloğunun altında) */
      .set-total-price {
        margin-top: 6px;
        font-size: 14px;
        line-height: 1.35;
      }
      .set-total-price__label { font-weight: 400; opacity: .85; }
      .set-total-price__value { font-weight: 700; }
      .set-total-price__note {
        display: inline-block;
        margin-left: 6px;
        font-size: 12px;
        opacity: .7;
      }

      /* SEPETE EKLENİYOR bekletme */
      .st-adding-notice {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 12px;
        padding: 10px 14px;
        background: #f8f9fa;
        border: 1px solid #e5e7eb;
        border-left: 4px solid #007cba;
        border-radius: 6px;
        font-size: 14px;
        color: #151515;
        animation: st-fade .25s ease;
      }
      .st-adding-spinner {
        flex: none;
        width: 16px; height: 16px;
        border: 2px solid rgba(0, 0, 0, .15);
        border-top-color: #007cba;
        border-radius: 50%;
        animation: st-spin .7s linear infinite;
      }
      @keyframes st-spin { to { transform: rotate(360deg); } }
      @keyframes st-fade { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: none; } }
    `;
    document.head.appendChild(style);
  }

  // ============================================================
  // SEPETE EKLEME: Concept product-form fetch('/cart/add') yakalama
  // ============================================================
  function forceMultiplier() {
    if (isInitialized) return;
    isInitialized = true;

    if (!initializeMultiplier()) {
      logError('Set multiplier initialization failed');
      return;
    }

    addQuantityLimitStyles();

    log('=== INITIALIZATION DEBUG ===');
    log('Size distribution:', sizeDistribution);
    log('Size variant stocks:', sizeVariantStocks);
    log('All size variants:', allSizeVariants);
    log('Is STD format:', Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD');
    log('=== END DEBUG ===');

    const originalFetch = window.fetch;

    window.fetch = async function (url, options = {}) {
      if (options && options.headers && typeof options.headers === 'object' && !(options.headers instanceof Headers) && options.headers[internalRequestFlag]) {
        const headers = { ...options.headers };
        delete headers[internalRequestFlag];
        return originalFetch.call(this, url, { ...options, headers });
      }

      const urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      if (urlStr && urlStr.includes('/cart/add')) {
        return handleSetCartRequest(originalFetch, url, options || {});
      }

      return originalFetch.call(this, url, options);
    };
    log('Fetch interceptor applied');

    // Sepet tipi "page" ise tema formu fetch'siz (native) gönderir → burada yakalayıp set olarak ekle
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form || !form.matches || !form.matches('form[is="product-form"]')) return;
      if (!isMainProductForm(form)) return;
      const isDesign = window.Shopify && Shopify.designMode;
      const nativeSubmit = !isDesign && (document.body.classList.contains('template-cart') || (window.theme && theme.settings && theme.settings.cartType === 'page'));
      if (!nativeSubmit) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      const fd = new FormData(form);
      window.fetch(((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add'), {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      }).then(async (r) => {
        let parsed = null;
        try { parsed = await r.json(); } catch (_) { /* ignore */ }
        if (parsed && parsed.status) {
          alert(parsed.description || parsed.message || t('cantAddIntegrityMsg'));
          return;
        }
        window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
      }).catch((err) => logError('page-mode add error', err));
    }, true);

    setTimeout(() => {
      setupQuantityListener();
      const initialQuantity = getCurrentQuantity();
      log(`Updating with initial quantity: ${initialQuantity}`);
      updateSetInfoOnQuantityChange(initialQuantity);
    }, 300);

    log('Set Multiplier active');
  }

  function parseAddBody(body) {
    const out = { quantity: 1, id: null, sections: null, sectionsUrl: null, properties: null, sellingPlan: null, itemsCount: 0, raw: null };
    if (!body) return out;

    const takeProp = (key, value) => {
      const m = key.match(/^properties\[(.*?)\]$/);
      if (m) {
        out.properties = out.properties || {};
        out.properties[m[1]] = value;
        return true;
      }
      return false;
    };

    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        for (const [k, v] of body.entries()) {
          if (k === 'id' || k === 'variant_id') out.id = String(v);
          else if (k === 'quantity') out.quantity = parseInt(v) || 1;
          else if (k === 'sections') out.sections = String(v);
          else if (k === 'sections_url') out.sectionsUrl = String(v);
          else if (k === 'selling_plan') out.sellingPlan = String(v);
          else takeProp(k, v);
        }
      } else if (typeof body === 'string') {
        let json = null;
        try { json = JSON.parse(body); } catch (_) { json = null; }
        if (json && typeof json === 'object') {
          out.raw = json;
          if (Array.isArray(json.items)) {
            out.itemsCount = json.items.length;
            const first = json.items[0] || {};
            out.id = first.id !== undefined ? String(first.id) : null;
            out.quantity = parseInt(first.quantity) || 1;
            if (first.properties) out.properties = first.properties;
            if (first.selling_plan) out.sellingPlan = String(first.selling_plan);
          } else {
            if (json.id !== undefined) out.id = String(json.id);
            if (json.variant_id !== undefined && !out.id) out.id = String(json.variant_id);
            if (json.quantity !== undefined) out.quantity = parseInt(json.quantity) || 1;
            if (json.properties) out.properties = json.properties;
            if (json.selling_plan) out.sellingPlan = String(json.selling_plan);
          }
          if (json.sections !== undefined) out.sections = Array.isArray(json.sections) ? json.sections.join(',') : String(json.sections);
          if (json.sections_url !== undefined) out.sectionsUrl = String(json.sections_url);
        } else {
          const params = new URLSearchParams(body);
          for (const [k, v] of params.entries()) {
            if (k === 'id' || k === 'variant_id') out.id = String(v);
            else if (k === 'quantity') out.quantity = parseInt(v) || 1;
            else if (k === 'sections') out.sections = String(v);
            else if (k === 'sections_url') out.sectionsUrl = String(v);
            else if (k === 'selling_plan') out.sellingPlan = String(v);
            else takeProp(k, v);
          }
        }
      }
    } catch (e) {
      log('parseAddBody error:', e);
    }

    out.quantity = Math.max(1, Math.floor(Math.abs(out.quantity) || 1));
    return out;
  }

  function jsonResponse(obj, status) {
    return new Response(JSON.stringify(obj), {
      status: status || 200,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function errorResponse(message) {
    return jsonResponse({ status: 422, message: 'Cart Error', description: message }, 422);
  }

  function copyHeaders(options) {
    const out = {};
    const h = options && options.headers;
    if (!h) return out;
    if (h instanceof Headers) {
      h.forEach((v, k) => { out[k] = v; });
    } else if (typeof h === 'object') {
      for (const k in h) out[k] = h[k];
    }
    delete out[internalRequestFlag];
    delete out['content-type'];
    delete out['Content-Type'];
    return out;
  }

  async function handleSetCartRequest(originalFetch, url, options) {
    const parsed = parseAddBody(options.body);

    // Bundle (çoklu items) istekleri set mantığına sokulmaz → temanın kendi akışı
    if (parsed.itemsCount > 1) {
      log('Multi-item (bundle) request passed through');
      return originalFetch.call(window, url, options);
    }

    if (isProcessingRequest) {
      return errorResponse(t('setProcessingMsg'));
    }

    isProcessingRequest = true;
    stSetAddLoading(true);

    try {
      const userQuantity = parsed.quantity;
      const selectedVariantId = parsed.id || getSelectedVariant();
      const build = buildSetItems(userQuantity, selectedVariantId);

      if (!build.success) {
        logError('Set adding failed:', build.errors);
        return errorResponse(build.errors.join('\n'));
      }

      const items = build.items.map(it => {
        const item = { id: it.id, quantity: it.quantity };
        if (parsed.properties) item.properties = parsed.properties;
        if (parsed.sellingPlan) item.selling_plan = parsed.sellingPlan;
        return item;
      });

      const payload = { items };
      if (parsed.sections) {
        const secs = parsed.sections.split(',').map(s => s.trim()).filter(Boolean);
        if (secs.length) payload.sections = secs;
      }
      if (parsed.sectionsUrl) payload.sections_url = parsed.sectionsUrl;

      const headers = copyHeaders(options);
      headers['Content-Type'] = 'application/json';
      if (!headers['Accept'] && !headers['accept']) headers['Accept'] = 'application/javascript';
      headers['X-Requested-With'] = 'XMLHttpRequest';

      log(`Adding set in ONE request: ${userQuantity} × set → ${build.totalAdded} pieces`, items);

      const response = await originalFetch.call(window, url, {
        ...options,
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        const formatInfo = isBedenSetiFormat ? t('formatSetSize') :
          isPaketYapisiFormat ? t('formatPackage') : t('formatSet');
        log(t('productsAddedMsg', { qty: userQuantity, formatInfo: formatInfo, total: build.totalAdded }), build.details);
        try {
          document.dispatchEvent(new CustomEvent('yakups:set-added', {
            detail: { quantity: userQuantity, totalAdded: build.totalAdded, details: build.details }
          }));
        } catch (_) { /* ignore */ }
      } else {
        logError('Cart add HTTP', response.status);
      }

      return response;

    } catch (error) {
      logError('Set request error:', error);
      return originalFetch.call(window, url, options);

    } finally {
      stSetAddLoading(false);
      setTimeout(() => { isProcessingRequest = false; }, 100);
    }
  }

  // Set → sepete eklenecek {id, quantity} listesi (stok/bütünlük doğrulamalı)
  function buildSetItems(userQuantity, selectedVariantId) {
    const results = { success: true, errors: [], details: [], totalAdded: 0, items: [] };

    if (isBedenSetiFormat) {
      let selectedRange = null;
      let multiplier = 1;
      const variantSize = getVariantSize(selectedVariantId);

      for (const [range, rangeMultiplier] of Object.entries(variantDistributions)) {
        if (isSizeInRange(variantSize, range)) {
          selectedRange = range;
          multiplier = rangeMultiplier;
          break;
        }
      }

      if (!selectedRange) {
        return { success: false, errors: [`Seçilen variant için uygun aralık bulunamadı: ${variantSize}`], details: [], totalAdded: 0, items: [] };
      }

      const finalQuantity = userQuantity * multiplier;
      const stockInfo = sizeVariantStocks[selectedVariantId];
      if (!stockInfo || stockInfo.stock < finalQuantity) {
        return { success: false, errors: [t('insufficientStockSimpleErr', { available: stockInfo ? stockInfo.stock : 0, needed: finalQuantity })], details: [], totalAdded: 0, items: [] };
      }

      results.items.push({ id: selectedVariantId, quantity: finalQuantity });
      results.details.push(`${selectedRange}: ${finalQuantity} adet`);
      results.totalAdded = finalQuantity;
      return results;
    }

    const isSTDFormat = Object.keys(sizeDistribution).length === 1 && Object.keys(sizeDistribution)[0] === 'STD';

    if (isSTDFormat) {
      const stdQuantity = sizeDistribution['STD'];
      const finalQty = stdQuantity * userQuantity;
      const variantId = allSizeVariants[0];
      if (!variantId) {
        return { success: false, errors: ['Variant bulunamadı'], details: [], totalAdded: 0, items: [] };
      }
      const stockInfo = sizeVariantStocks[variantId];
      if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null && stockInfo.stock < finalQty) {
        return { success: false, errors: [t('insufficientStockSimpleErr', { available: stockInfo.stock, needed: finalQty })], details: [], totalAdded: 0, items: [] };
      }
      log(`STD Format: Adding ${finalQty} items of variant ${variantId}`);
      results.items.push({ id: variantId, quantity: finalQty });
      results.details.push(`STD: ${finalQty} adet`);
      results.totalAdded = finalQty;
      return results;
    }

    if (isPaketYapisiFormat) {
      const finalQty = paketMultiplier * userQuantity;
      const variantId = allSizeVariants[0];
      if (!variantId) {
        return { success: false, errors: ['Variant bulunamadı'], details: [], totalAdded: 0, items: [] };
      }
      const stockInfo = sizeVariantStocks[variantId];
      if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null && stockInfo.stock < finalQty) {
        return { success: false, errors: [t('insufficientStockSimpleErr', { available: stockInfo.stock, needed: finalQty })], details: [], totalAdded: 0, items: [] };
      }
      log(`Paket Format: Adding ${finalQty} items of variant ${variantId}`);
      results.items.push({ id: variantId, quantity: finalQty });
      results.details.push(`Paket: ${finalQty} adet`);
      results.totalAdded = finalQty;
      return results;
    }

    // Traditional set format (her beden ayrı satır, TEK istek)
    const validation = validateSetIntegrity(userQuantity, sizeDistribution);
    if (!validation.isValid) {
      return { success: false, errors: validation.errors, details: [], totalAdded: 0, items: [] };
    }

    log(`Set integrity validated. Building ${userQuantity} sets...`);

    for (const [size, baseQty] of Object.entries(sizeDistribution)) {
      const finalQty = baseQty * userQuantity;
      const variantId = findVariantIdBySize(size);

      if (!variantId) {
        results.errors.push(t('sizeNotFoundErr', { size: size }));
        continue;
      }

      const stockInfo = sizeVariantStocks[variantId];
      if (stockInfo && stockInfo.stock !== undefined && stockInfo.stock !== null && stockInfo.stock < finalQty) {
        results.errors.push(`${size} ${t('insufficientStockSimpleErr', { available: stockInfo.stock, needed: finalQty })}`);
        continue;
      }

      results.items.push({ id: variantId, quantity: finalQty });
      results.details.push(`${size}: ${finalQty} adet`);
      results.totalAdded += finalQty;
    }

    if (results.errors.length > 0 || results.items.length === 0) {
      results.success = false;
    }

    return results;
  }

  function getVariantSize(variantId) {
    const stockInfo = sizeVariantStocks[variantId];
    if (stockInfo) {
      return stockInfo.sizeName;
    }

    const variantIndex = allSizeVariants.indexOf(String(variantId));
    if (variantIndex !== -1 && variantIndex < availableSizes.length) {
      return availableSizes[variantIndex];
    }

    return 'UNKNOWN';
  }

  function isSizeInRange(size, range) {
    const cleanSize = size.replace(/[()]/g, '').trim();
    const cleanRange = range.trim();

    if (cleanSize === cleanRange) {
      return true;
    }

    const rangeParts = cleanRange.split('-');
    if (rangeParts.length !== 2) {
      return false;
    }

    const rangeStart = parseInt(rangeParts[0]);
    const rangeEnd = parseInt(rangeParts[1]);

    if (cleanSize.includes('-')) {
      const sizeParts = cleanSize.split('-');
      if (sizeParts.length === 2) {
        const sizeStart = parseInt(sizeParts[0]);
        const sizeEnd = parseInt(sizeParts[1]);
        return sizeStart === rangeStart && sizeEnd === rangeEnd;
      }
    } else {
      const sizeNum = parseInt(cleanSize);
      if (!isNaN(sizeNum) && !isNaN(rangeStart) && !isNaN(rangeEnd)) {
        return sizeNum >= rangeStart && sizeNum <= rangeEnd;
      }
    }

    return false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceMultiplier);
  } else {
    forceMultiplier();
  }

})();
